module.exports = __webpack_public_path__ + "catalog/items/bathroom/Bath-With-Shower-Area/Bath-With-Shower-Area.svg";